import React from 'react'
import momentTimezone from 'moment-timezone'
import { useTranslation } from 'react-i18next'

const tooltipStyle = {
    margin: '0px',
    padding: '10px',
    backgroundColor: 'rgb(255, 255, 255)',
    border: '1px solid rgb(204, 204, 204)',
    whiteSpace: 'nowrap',
}

const tooltipContentStyle = {
    margin: "3px",
    whiteSpace: 'normal',
}

const tootlTipValueStyle = {
    color: "#59CBE4"
}

const tootlTipValueStyleStoppage = {
    color: "#00E396"
}

const getStoppageText = (isBreak) => {
    return isBreak ? 'Unplanned Stop' : 'Planned Stop'
}


const CustomDateTooltip = ({chartObject, timezone}) => {
    const { t } = useTranslation()
    const { i18n } = useTranslation()
    momentTimezone.locale(i18n.language)
 
    if (chartObject) {
        if(chartObject.reason){
            return (
                <div style={tooltipStyle} >
                    <p style={{ ...tooltipContentStyle, ...tootlTipValueStyleStoppage }}>{t(getStoppageText(chartObject.isbreak)) + ': ' + chartObject.reason}</p>
                    <p style={tooltipContentStyle}>{momentTimezone.utc(chartObject.start_time).tz(timezone).format('LLL')}</p>
                    <p style={tooltipContentStyle}>{momentTimezone.utc(chartObject.end_time).tz(timezone).format('LLL')}</p>
                </div>
            )
        }
        else {
            return (
                <div style={tooltipStyle} >
                    <p style={{ ...tooltipContentStyle, ...tootlTipValueStyle }}>{t('Tally Number') + ': ' + chartObject.name}</p>
                    <p style={{ ...tooltipContentStyle }}>{t('Depth') + ': ' + chartObject.y.toFixed(2)}</p>
                    <p style={tooltipContentStyle}>{momentTimezone.utc(chartObject.date).tz(timezone).format('LLL')}</p>
                    {chartObject.comments ? <p style={tooltipContentStyle}>Comments: {chartObject.comments}</p> : null}
                </div>
            )
        }
        
    }

    return null
}

export default CustomDateTooltip